import Vue from "vue";

export const mutations = {
  SET_LOADER: (state, payload: boolean): boolean => Vue.set(state, "loader", payload),
  SET_RESET_PASSWORD_USER_EMAIL: (state, payload: string): string => Vue.set(state, "resetPasswordEmail", payload),
  SET_IS_USER_EMAIL_VERIFIED: (state, payload: boolean): boolean => Vue.set(state, "isUserEmailVerified", payload),
}
